interface ErrorBannerProps {
  message: string;
  onRetry?: () => void;
  context?: string;
}

export function ErrorBanner({ message, onRetry, context }: ErrorBannerProps) {
  return (
    <div className="panel p-6 border-[var(--color-status-error)]/40 bg-[rgba(239,68,68,0.04)]">
      <div className="flex items-start gap-4">
        <span
          className="mt-1 inline-block w-2 h-2 rounded-full"
          style={{ background: "var(--color-status-error)" }}
        />
        <div className="flex-1">
          <p className="eyebrow text-[var(--color-status-error)]">
            {context ? `Could not load ${context}` : "Something went wrong"}
          </p>
          <p className="font-display italic text-2xl mt-2 text-[var(--color-text)]">
            The Worker didn&apos;t respond.
          </p>
          <p className="mt-2 font-mono text-xs text-[var(--color-text-muted)] break-all">
            {message}
          </p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded border border-[var(--color-border-strong)] text-[var(--color-text)] hover:border-[var(--color-accent)] transition-colors font-mono text-[11px] tracking-wider uppercase"
            >
              Retry
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
